import type { ReactNode } from 'react';
import {
  DEFAULT_COLOR,
  DEFAULT_WAI_ARIA_ATTRIBUTE,
  FULLSCREEN_STYLE_ATTRIBUTES,
} from './types';
import { TailSpin } from './loader/tailspin';
import { ThreeDots } from './loader/three-dots';
import './base.css';

export type BaseLoaderProps = {
  loader?: string;
  fullscreen?: boolean;
  color?: string;
  children?: ReactNode;
  text?: string;
  [key: string]: any; // loader props
};

export const LoaderMap = {
  tailspin: TailSpin,
  threedots: ThreeDots,
};

export function Loader({
  loader = 'tailspin',
  fullscreen = true,
  text,
  style = {},
  ...loaderProps
}: BaseLoaderProps) {
  const LoaderComponent = LoaderMap[loader];

  const color = loaderProps.color || DEFAULT_COLOR;
  const fullScreenStyleAttributes = fullscreen
    ? FULLSCREEN_STYLE_ATTRIBUTES
    : {};

  return (
    <div
      className="ui-loader-wrapper"
      style={{
        zIndex: 2,
        pointerEvents: 'none',
        userSelect: 'none',
        display: 'flex',
        ...fullScreenStyleAttributes,
        ...DEFAULT_WAI_ARIA_ATTRIBUTE,
        ...style
      }}
    >
      <LoaderComponent {...loaderProps} />
      {text && (
        <span
          className="ui-loader-text"
          style={{
            fontSize: `var(--ui-loader-text-font-size, clamp(24px, 6vw, 4rem))`,
            color: `var(--ui-loader-text-color, ${color})`,
          }}
        >
          {text}
        </span>
      )}
    </div>
  );
}
